"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from "react";

/** Must match DEMO_PROMPT_LIMIT in src/lib/demo/demo-limit.ts. */
const DEMO_PROMPT_LIMIT = 40;
function readCount(): number {
  if (typeof document === "undefined") return 0;
  const m = document.cookie.match(/(?:^|; )iloris_demo_count=(\d+)/);
  const n = m ? parseInt(m[1], 10) : 0;
  return Number.isFinite(n) && n >= 0 ? n : 0;
}

/**
 * Reflects the server-side prompt counter (the `iloris_demo_count` cookie the
 * demo route sets) into React. Polls so the count updates after each AI turn
 * without threading callbacks through the shared assistant sidebar.
 */
export function useDemoPrompts() {
  const $ = _c(6);
  const [used, setUsed] = useState(_temp);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const id = setInterval(() => setUsed(readCount()), 1500);
      return () => clearInterval(id);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  const t2 = Math.max(0, DEMO_PROMPT_LIMIT - used);
  const t3 = used >= DEMO_PROMPT_LIMIT;
  let t4;
  if ($[2] !== t2 || $[3] !== t3 || $[4] !== used) {
    t4 = {
      used,
      remaining: t2,
      limit: DEMO_PROMPT_LIMIT,
      reachedLimit: t3
    };
    $[2] = t2;
    $[3] = t3;
    $[4] = used;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
}
function _temp() {
  return readCount();
}